// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueRouter from 'vue-router'
import store from './store'
import VueI18n from 'vue-i18n'
import {
  languages,
  defaultLocale
} from './i18n'
import Home from 'components/Home'
import AbountUs from 'components/company/aboutus'
import Culture from 'components/company/culture'
import Rnd from 'components/company/rnd'
import Knowledge from 'components/service/knowledge'
import Maintenance from 'components/service/maintenance'
import Rotation from 'components/service/rotation'
import Driving from 'components/service/driving'
import Sidewall from 'components/service/sidewall'
import Warranty from 'components/service/warranty'
import Download from 'components/service/download'
import News from 'components/media/news'
import NewsDetail from 'components/media/newsdetail'
import Video from 'components/media/video'
import Interaction from 'components/media/interaction'
import Products from 'components/product/products'
import ProductDetail from 'components/product/productdetail'
import VueCookies from 'vue-cookies'
import SwiperTest from 'components/product/testswiper'
import consts from './consts';

Vue.use(VueI18n)
Vue.use(VueCookies)
Vue.use(VueRouter)
Vue.component('home', Home)
Vue.component('aboutus', AbountUs)
Vue.component('culture', Culture)
Vue.component('rnd', Rnd)
Vue.component('knowledge', Knowledge)
Vue.component('maintenance', Maintenance)
Vue.component('rotation', Rotation)
Vue.component('driving', Driving)
Vue.component('sidewall', Sidewall)
Vue.component('warranty', Warranty)
Vue.component('download', Download)
Vue.component('news', News)
Vue.component('newsdetail', NewsDetail)
Vue.component('video', Video)
Vue.component('interaction', Interaction)
Vue.component('products', Products)
Vue.component('productdetail', ProductDetail)
Vue.component('swiperTest', SwiperTest)

const messages = Object.assign(languages)

Vue.config.productionTip = false

VueCookies.config('1d')
var current_lang = VueCookies.get(consts.COOKIE_LANG);
if (!current_lang) {
  current_lang = defaultLocale;
  VueCookies.set(consts.COOKIE_LANG, 'en')
  window.location.href = consts.DEFAULT_HOST
}

var i18n = new VueI18n({
  locale: current_lang,
  fallbackLocale: 'en',
  messages: messages
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js